import React from 'react';
import PropTypes from 'prop-types';
import { SearchableSelectField } from 'components/Backoffice/form/SearchableSelectField';
import { useFeeScheduleProgramOptions } from '../../hooks';

export const ServiceProvidedFilter = ({
  className,
  labelClassName,
  onChange,
  value,
}) => {
  const servicesProvided = useFeeScheduleProgramOptions();
  return (
    <SearchableSelectField
      className={className}
      label="Service Provided"
      labelClassName={labelClassName}
      onChange={({ value: val }) => onChange(val)}
      options={servicesProvided}
      placeholder="Choose Service Provided"
      value={value ?? ''}
      truncateOptions={false}
      clearable
    />
  );
};

ServiceProvidedFilter.propTypes = {
  className: PropTypes.string,
  labelClassName: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
};

ServiceProvidedFilter.defaultProps = {
  className: undefined,
  labelClassName: undefined,
  value: undefined,
};
